export default "__VITE_ASSET__HSxu6vyE__"